import { Image } from "@/components/common/Image"
import { FormattedMessage } from "react-intl"
import { Button } from "../Button"

export const BuyCryptocurrency = () => {
  return (
    <div className="text-center">
      <div className="box box-light">
        <div className="buy-payments">
          <Image src="mastercard.svg" alt="mastercard" />
          <Image src="visa.svg" alt="visa" />
        </div>
        <h3 className="h3 buy-title">
          <FormattedMessage id="buy" />
          {` `}
          <FormattedMessage id="cryptocurrency" />
        </h3>
        <p className="buy-payments__des">
          <FormattedMessage id="just_use" />
        </p>
        {/* <Button rel="noreferrer" onClick={() => window.open(process.env.REACT_APP_BUY_CRYPTO_URL)} style={{ width: "100%" }}>
          <FormattedMessage id="buy_coins" />
        </Button> */}
        <Button rel="noreferrer" style={{ width: "100%" }}>
          <FormattedMessage id="buy_coins" />
        </Button>
      </div>
    </div>
  )
}
